import { createSelector } from 'reselect';
import { highlightBNPLBasketSelector } from 'selectors/testTarget/offers/highlightBNPLBasket/highlightBNPLBasketSelector';

const showSelector = createSelector(highlightBNPLBasketSelector, highlightBNPLBasket => !!highlightBNPLBasket.show);

export { showSelector };
